<span class="text" #columnName>
    <ng-content></ng-content>
</span>
<span class="icon-wrapper" [ngClass]="arrowDirection">
    <mat-icon svgIcon="arrow-downward" class="sort-icon" [class.hint-visible]="arrowVisible"></mat-icon>
</span>
